import { ExportColumn } from '../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'name',
    header: 'Products',
    type: 'text',
    width: 45,
  },
  {
    key: 'monthsOnHand',
    header: 'Finished Goods Inventory (months)',
    type: 'number',
    width: 45,
  },
  {
    key: 'revenueEquivalent',
    header: 'Revenue Equivalent',
    type: 'money',
    width: 45,
  },
];
